import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

const StyledProductName = styled.p`
  display: -webkit-box;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  overflow: hidden;
  color: ${({ theme }) => theme.colors.gr2ProductCardName};
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
  font-size: 14px; /* desktop */
  font-style: normal;
  font-weight: 350;
  line-height: 16/14;
  ${mobile`
    font-size: 12px;
  `}
`;

function ProductName({ children, isUnavailable = false }) {
  return (
    <StyledProductName
      isUnavailable={isUnavailable}
      data-qa-automation="gridSetsProdName"
      data-autotag="grid-product-name"
    >
      {children}
    </StyledProductName>
  );
}

ProductName.propTypes = {
  children: PropTypes.node.isRequired,
  isUnavailable: PropTypes.bool,
};

export default ProductName;
